export enum SensorConnectionStatus {
  online = 1,
  offline = 0,
  notReady = 2,
}

export enum SensorSkuId {
  Weight = 'Weight',
  CV = 'CV',
  Expiry = 'Expiry CV',
  Hanger = 'Hanger',
}
